import PropTypes from 'prop-types';
import { Component } from 'react';
import T from 'Components/Helpers/translate';

class UpProductCategory extends Component {
	componentDidUpdate() {
		const selectHelper = ReactTemplates.TOOLS.selectHelper;
		selectHelper.updateValue.call(this);
	}

	componentDidMount() {
		let opts = {
			required: this.props.required || false,
			multiple: this.props.multiple || false,
			placeholder: this.props.placeholder || ' ',
			onChange: this.props.onChange,
			ajax: false,
			asIds: false,
			emptyMsg: T('default.noName'),
			formatResult: this.props.formatResult || ((object, container, query, escape) => escape(object.name)),
			formatSelection: this.props.formatSelection || ((object, container, escape) => escape(object.name)),
			data: this.getData(),
			select2: {
				minimumInputLength: 1
			}
		};

		if (this.props.data) {
			opts.data = undefined;

			opts.select2.ajax = {
				data: function (term) {
					return term;
				},
				transport: function (query) {
					var data = this.props.data;
					if (query.data && query.data.length) {
						data = _.filter(this.props.data, function (item) {
							return item.name.toLowerCase().indexOf(query.data.toLowerCase()) !== -1;
						});
					}

					return query.success(data);
				},
				results: function (data) {
					return { results: data };
				}
			};
		}

		const input = jQuery(this._input);

		const selectHelper = ReactTemplates.TOOLS.selectHelper;
		opts = _.merge({}, opts, this.props.options);
		selectHelper.getSelect2Options(this, opts, input, options => {
			input.select2(options);
		});
	}

	componentWillUnmount() {
		const input = jQuery(this._input);
		input.select2('destroy');
	}

	getData() {
		return Tools.AppService.getProductCategories();
	}

	render() {
		const selectHelper = ReactTemplates.TOOLS.selectHelper;
		return selectHelper.getInputComponent(this);
	}
}
UpProductCategory.propTypes = {
	onlyActive: PropTypes.bool,
	multiple: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
	placeholder: PropTypes.string,
	options: PropTypes.object,
	formatResult: PropTypes.func,
	formatSelection: PropTypes.func,
	data: PropTypes.array
};

export default UpProductCategory;
